export class GrowerOrderData {
  growerOrderId: number;
  growerName: string;
  growerAddress: string;
  orderID: string;
  unit: string;
  accountNo: string;
  lastUpdatedAt: Date;
  orderType: string;
  city: string;
  state: string;
  zip: string;
  gln: string;
  gmk: number;
  EmailTo: string;
  wfusB2BEnablement: string;
  isAccountRIB: boolean;
}
